// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__cKKP-","upload":"Small_upload__8xIZ8","imageWrap":"Small_imageWrap__2p3hp","removeBtn":"Small_removeBtn__7h3Qi"};